module.exports = __webpack_public_path__ + "static/media/plane(19).6b812d13.PNG";